import { z } from "zod";
import { TimepotDate } from "models/TimepotDate";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const EmploymentPeriod = z.object({
    id: z.number(),
    startDate: TimepotDate,
    endDate: TimepotDate.nullable().optional(),
});

export type EmploymentPeriod = z.infer<typeof EmploymentPeriod>;

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const EmploymentPeriods = z.object({
    employmentPeriods: EmploymentPeriod.array(),
});

export type EmploymentPeriods = z.infer<typeof EmploymentPeriods>;
export { EmploymentPeriods };
